
const tagIcons = {
  Adjective: '🔤',
  Adverb: '⚡',
  Business: '💼',
  Expression: '💬',
  Food: '🍽️',
  General: '📚',
  Poetry: '🎭',
  Verb: '🏃',
  Untagged: '🏷️',
};

export const getTagIcon = (tag) => tagIcons[tag] || '🏷️';
